import angular from 'angular';
import _ from 'lodash';

angular.module('printersNew', ['application']).config(["$stateProvider", "$translatePartialLoaderProvider", function($stateProvider: any, $translatePartialLoaderProvider: any) {
    $translatePartialLoaderProvider.addPart('printers');

    $stateProvider.state('app.new.settings.printers.general', {
        url: '/general',
        template: `<general-settings />`
    });

    $stateProvider.state('app.new.settings.printers.detail', {
        url: '/detail/:id',
        template: `<printer-details />`
    });

    $stateProvider.state('app.new.settings.printers.new', {
        url: '/new',
        template: `<new-printer />`
    });
}]);